export class FileConfig {
    constructor(file, url, oldfile) {
        this.file = file;
        this.url = url;
        this.oldfile = oldfile;
        this.config = {
            pagesPerSheet: '1',
            landscape: false,
            scale: '100',
            isColor: false,
            singleBWPages: "",
            singleColorPages: "",
            bothSideBWPages: "",
            bothSideColorPages: "",
            bothSideBWAndColorPages: "",
            pageSize: "A4",
            coloridx: 0,
            pgRange: "All",
            bpgRange: "All",
            pgarr: "",
            singlePage: "",
            bothPage: "",
            sBWpg: "",
            scolorpg: "",
            bsBWpg: "",
            bscolorpg: "",
            bsBWandcolorpg: "",
            sideIcon: 0
        };
    }
}
